import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { ColumnSize } from '../Column';
const Gutter = {
  small: 'row-sm',
  large: 'row-lg',
  xlarge: 'row-xl'
};
const getClasses = props => cx(ColumnSize.reduce((obj, size) => ({
  ...obj,
  [`${props[`${size}VerticalAlign`]}-${size}`]: !!props[`${size}VerticalAlign`],
  [`${props[`${size}HorizontalAlign`]}-${size}`]: !!props[`${size}HorizontalAlign`],
  [`${props[`${size}Distribution`]}-${size}`]: !!props[`${size}Distribution`]
}), {}));
export default function Row({
  children,
  className = null,
  gutter,
  reverse = false,
  ...props
}) {
  const {
    xsVerticalAlign,
    smVerticalAlign,
    mdVerticalAlign,
    lgVerticalAlign,
    xsHorizontalAlign,
    smHorizontalAlign,
    mdHorizontalAlign,
    lgHorizontalAlign,
    xsDistribution,
    smDistribution,
    mdDistribution,
    lgDistribution,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx(className, 'row', {
      [Gutter[gutter]]: !!gutter,
      reverse
    }, getClasses(props))
  }, rest), children);
}
const verticalAlign = PropTypes.oneOf(['top', 'middle', 'bottom']);
const horizontalAlign = PropTypes.oneOf(['start', 'center', 'end']);
const distribution = PropTypes.oneOf(['around', 'between']);
Row.propTypes = {
  className: PropTypes.string,
  gutter: PropTypes.oneOf(Object.keys(Gutter)),
  xsVerticalAlign: verticalAlign,
  smVerticalAlign: verticalAlign,
  mdVerticalAlign: verticalAlign,
  lgVerticalAlign: verticalAlign,
  xsHorizontalAlign: horizontalAlign,
  smHorizontalAlign: horizontalAlign,
  mdHorizontalAlign: horizontalAlign,
  lgHorizontalAlign: horizontalAlign,
  xsDistribution: distribution,
  smDistribution: distribution,
  mdDistribution: distribution,
  lgDistribution: distribution,
  reverse: PropTypes.bool,
  children: PropTypes.node
};
//# sourceMappingURL=index.js.map